<template>
    <ContentOrLoading>
        <div class="row" v-if="! loading">
            <div class="col-12 text-center p-3 lightgray-content">
                <div v-if="tipo_svg === 1">
                    <SvgPanZoom 
                        class="svgpanzoom-container"
                        :zoomEnabled="true"
                        :controlIconsEnabled="false"
                        :fit="true"
                        :center="true"
                        :mouseWheelZoomEnabled="false"
                        :zoomScaleSensitivity="2"
                        :dblClickZoomEnabled="false"
                        :preventMouseEventsDefault="false"
                        @svgpanzoom="registerSvgPanZoom"
                    >
                        <svg v-html="svg_loaded"/>
                    </SvgPanZoom>
                    <div class="text-center" v-if="load_panzoom">
                        <button @click="zoomIn()" class="button panzoom-button">+</button>
                        <button @click="zoomOut()" class="button panzoom-button">-</button>
                    </div>
        
                    <template v-if="!loading">
                        <b-popover
                            v-for="plaza in plazas"
                            :key="plaza.id"
                            :target="'popover-' + plaza.id" 
                            triggers="hover focus"
                        >
                            <template slot="title">{{ plaza.name }}</template>
    
                            <div v-if="plaza.disponible && plaza.precios.length > 0">{{ $t('general.desde') + ': ' + getPrecioPlaza(plaza) | formatear_precio }} </div>
                            <div v-else-if="! plaza.disponible && plaza.precios.length > 0">{{ $t('partido.ocupado') }}</div>
                            <div v-else>{{ $t('mapa.no_disponible') }}</div>
                        </b-popover>
                    </template>
                </div>
                <LeafletComponent
                    v-else
                    :plazasSeleccionadas="plazasSeleccionadas"
                    :continuarConCompra="continuarConCompra"
                    :svgRendered="svgRendered"
                    :originalColor="originalColor"
                    :disabled="bloquearPasoDos"
                    @isPanning="(e) => isPanning = e"
                />
            </div>
            <template v-if="taquilla">
                <div class="col-12 mt-4">
                    <LeyendaColorEventos />
                </div>
                <div class="col-12 d-md-flex align-items-center mt-4">
                    <div>
                        <FormInput label="Número de butacas" type="number" max="100" name="n_butacas" v-model="n_butacas" />
                    </div>
                    <div class="ml-3">
                        <Button class="m-1" @click="selectButacas" :disabled="n_butacas === 0 || n_butacas > 30">Seleccionar</Button>
                        <Button class="m-1" @click="selectAllButacas" :disabled="bloquearPasoDos">Seleccionar todas</Button>
                        <Button class="m-1" @click="clearButacas" :disabled="disabled || bloquearPasoDos">Borrar selección</Button>
                    </div>
                </div>
            </template>
        </div>
    </ContentOrLoading>
</template>

<script>
    import SvgPanZoom from 'vue-svg-pan-zoom';
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import { Popover } from 'bootstrap';
    import LeyendaColorEventos from '@/views/backend/events/sesiones/bloquear-asientos/LeyendaColorEventos.vue';

    export default {
        props: ['region_id', 'plazas', 'continuarConCompra', 'tipo_svg', 'plazasSeleccionadas', 'disabled', 'plazaParaBorrar', 'bloquearPasoDos'],
        data() {
            return {
                svg_loaded : '',
                loading: true,
                can_click: true,
                svgpanzoom: null,
                svg: null,
                svgRendered: null,
                originalColor: '#0CBA31',
                noDisponibleColor: 'gray',
                seleccionadaColor: '#8CA9D9',
                bloqueadaEventosColor: '#BF95C4', 
                enSesionEventosColor: 'yellow', 
                vendidaEventosColor: 'red',
                bloqueadaAbonosColor: 'purple', 
                enSesionAbonosColor: 'orange', 
                vendidaAbonosColor: 'black',
                validadaColor: '#01018A',
                isPanning: null,
                n_butacas: 0
            }            
        },
        created() {
            this.getSvg();
        },
        watch: {
            plazaParaBorrar(newPlaza) {
                if (newPlaza) {
                    this.clickRegion(newPlaza.id);
                    const butaca = document.querySelector(`[id^="butaca-${newPlaza.svg_id}"]`) || document.querySelector(`[id^="butaca-${newPlaza.svg_id}-"]`) ;
                    if (butaca) {
                        butaca.setAttribute('fill', this.originalColor);
                        butaca.setAttribute('seleccionado', 'false');
                    }
                    this.$emit('setPlazaBorrar', newPlaza)
                }
            }
        },
        computed: {
            load_panzoom() {
                let load_panzoom = true

                let userAgent = navigator.userAgent || navigator.vendor || window.opera;

                if(/windows phone/i.test(userAgent)) {
                    load_panzoom = false;
                }
            
                if(/android/i.test(userAgent)) {
                    load_panzoom = false;
                }

                if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    load_panzoom = false;
                }

                return load_panzoom;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            taquilla() {
                var path = this.$router.currentRoute.fullPath;

                return path.includes('admin');
            }
        },
        methods: {
            registerSvgPanZoom(svgpanzoom) {
                this.svgpanzoom = svgpanzoom;
            },
            zoomIn : function() {
                this.svgpanzoom.zoomIn();
            },
            zoomOut : function() {
                this.svgpanzoom.zoomOut();
            },
            getPrecioPlaza({ precios }) {
                if (precios.length > 0) {
                    let precioMasBajo = precios.reduce((menorPrecio, precio) => {
                        return Math.min(menorPrecio, precio.precio);
                    }, Number.POSITIVE_INFINITY)                
                
                    return Math.ceil(precioMasBajo * 100) / 100;
                }

                return 0;
            },
            getSvg() {
                this.loading = true;

                let params = {
                    filters: {},
                    event_id: this.$route.params.event_id ?? this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    region_id: this.region_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.zonas.recintos-anexos.svg'), params)
                    .then(({ data: { svg } }) => {
                        if (this.tipo_svg === 1) {
                            this.loadSVG(svg);
                        } else if (this.tipo_svg === 2) {
                            this.renderLeafletSvg(svg);
                        }
                        this.loading = false;
                    }).catch(error => {
                        console.log(error);
                        console.warn('Error al recuperar el SVG del recinto anexo');
                    })
            },
            loadSVG(svg) {
                this.svg_loaded = svg;

                let vue_instance = this;

                setTimeout(() => {
                    let plazas = document.getElementsByClassName("recinto-zona");

                    for(let i in plazas) {
                        if(plazas[i].dataset !== undefined) {
                            let plaza_id = plazas[i].dataset.region;

                            for(let j in this.plazas) {
                                if(this.plazas[j].id == plaza_id && this.plazas[j].precios.length == 0) {
                                    plazas[i].classList.add("no-disponible");
                                }

                                if (this.plazas[j].id == plaza_id && !this.plazas[j].disponible) {
                                    plazas[i].classList.add("plaza_ocupada");                                
                                }

                                if (this.plazas[j].id == plaza_id && this.plazas[j].disponible && this.plazas[j].precios.length > 0) {
                                    plazas[i].classList.add("plaza_disponible");                                
                                }
                            }

                            plazas[i].addEventListener('click', function() {
                                vue_instance.clickRegion(this.dataset.region);
                            }, false);
                        }                                                                                            
                    }
                }, 500);                
            },
            clickRegion: function(plaza_id) {
                if (!this.continuarConCompra) {
                    let plaza = this.plazas.find(plaza => plaza.id == plaza_id);
    
                    if (plaza && plaza.precios.length > 0 && (plaza.libre || plaza.disponible)) {
                        this.$emit('clickZona', plaza);
                    }                
                }
            },
            clearButacas() {
                for (var plaza in this.plazas) {
                    if(this.plazas[plaza].seleccionada) {
                        const butaca = document.querySelector(`[id^="butaca-${this.plazas[plaza].svg_id}-"]`);
                        if (butaca) {
                            butaca.setAttribute('fill', this.originalColor);
                            butaca.setAttribute('seleccionado', 'false');
                            delete this.plazas[plaza].seleccionada;
                        }

                        this.$emit('clearButacas');
                    }
                }
            },
            selectButacas() {
                var count = this.n_butacas <= 100 ? this.n_butacas : 100;

                for (var plaza in this.plazas) {
                    if(!this.plazas[plaza].seleccionada && this.plazas[plaza].precios.length > 0 && (this.plazas[plaza].libre || this.plazas[plaza].disponible) && count > 0) {
                        this.clickRegion(this.plazas[plaza].id);
                        count--;

                        const butaca = document.querySelector(`[id^="butaca-${this.plazas[plaza].svg_id}-"]`);
                        if (butaca) {
                            butaca.setAttribute('fill', this.seleccionadaColor);
                            butaca.setAttribute('seleccionado', 'true');
                        }
                    }
                }
            },
            selectAllButacas() {
                var count = 0;

                for (var plaza in this.plazas) {
                    if(this.plazas[plaza].precios.length > 0 && (this.plazas[plaza].libre || this.plazas[plaza].disponible) && count < 100) {
                        this.clickRegion(this.plazas[plaza].id);

                        const butaca = document.querySelector(`[id^="butaca-${this.plazas[plaza].svg_id}-"]`);
                        if (butaca) {
                            butaca.setAttribute('fill', this.seleccionadaColor);
                            butaca.setAttribute('seleccionado', 'true');
                        }

                        count++;
                    }
                }
            },
            renderLeafletSvg(svg) {
                const plazasFiltered = this.plazas.filter(plaza => plaza.svg_id);

                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = svg;
            
                const svgElement = tempDiv.firstElementChild;
                const butacas = svgElement.querySelectorAll('[id^="butaca"]');
            
                butacas.forEach(circle => {
                    circle.setAttribute('seleccionado', 'false');
                    const svg_id = this.getButacaId(circle);
                    const plaza = plazasFiltered.find(plaza => plaza.svg_id == svg_id);
                
                    if (plaza) {
                        const title = this.getButacaName(plaza);
                    
                        if (plaza.precios.length === 0) {
                            circle.setAttribute('ocupada', 'true');
                            circle.style.cursor = 'not-allowed';
                            circle.setAttribute('fill', this.noDisponibleColor);
                            this.drawPopover(circle, plaza, title); 
                        } else if ((plaza.libre || plaza.disponible) && plaza.precios.length > 0) {
                            this.drawPopover(circle, plaza, title); 
                
                            circle.style.cursor = 'pointer';
                            circle.style.transition = 'fill 0.2s';
                            circle.setAttribute('fill', this.originalColor);

                            circle.addEventListener('click', () => {
                                let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                                setTimeout(() => {
                                    if (!this.isPanning && !this.continuarConCompra && !this.bloquearPasoDos) {
                                        if (!isSeleccionado) {
                                            circle.setAttribute('fill', this.seleccionadaColor);
                                            circle.setAttribute('seleccionado', 'true');
                                        } else {
                                            if (plaza.etiqueta_bloqueo) {
                                                circle.setAttribute('fill', plaza.etiqueta_bloqueo.color);
                                            } else {
                                                circle.setAttribute('fill', this.originalColor);
                                            }
                                            circle.setAttribute('seleccionado', 'false');
                                        }
                                        this.clickRegion(plaza.id);
                                    }
                                }, 150);
                            });
                        } else if (plaza.ocupada && plaza.ocupada.bloqueada) {
                            if (plaza.ocupada.reserva_id) {
                                circle.setAttribute('ocupada', 'true');
                                circle.style.cursor = 'not-allowed';
                                circle.setAttribute('fill', this.bloqueadaEventosColor);
                                this.drawPopover(circle, plaza, title); 
                            } else {
                                this.drawPopover(circle, plaza, title);    
                                circle.setAttribute('fill', this.bloqueadaEventosColor);
                            }

                            if (plaza.etiqueta_bloqueo) {
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', plaza.etiqueta_bloqueo.color);
                                this.drawPopover(circle, plaza, title); 
                            }

                            if (plaza.info_ocupada && plaza.info_ocupada.concepto) {
                                let content = `<div><strong>Concepto: </strong>${plaza.info_ocupada.concepto}</div>`
                                this.drawPopover(circle, plaza, title, content); 
                            }

                            if (!plaza.ocupada.reserva_id) {
                                if (this.checkDisponibilidad(plaza)) {
                                    plaza.libre = true;
                                    plaza.disponible = true;
                                }
                                circle.addEventListener('click', () => {
                                    let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));
    
                                    setTimeout(() => {
                                        if (!this.isPanning) {
                                            if (!isSeleccionado) {
                                                circle.setAttribute('fill', this.seleccionadaColor);
                                                circle.setAttribute('seleccionado', 'true');
                                            } else {
                                                if (plaza.etiqueta_bloqueo) {
                                                    circle.setAttribute('fill', plaza.etiqueta_bloqueo.color);
                                                } else {
                                                    circle.setAttribute('fill', this.bloqueadaEventosColor);
                                                }
                                                circle.setAttribute('seleccionado', 'false');
                                            }
                                            this.clickRegion(plaza.id);
                                        }
                                    }, 150);
                                }); 
                            }
                        } else if (plaza.ocupada && plaza.ocupada.sesion) {
                            circle.setAttribute('ocupada', 'true');
                            circle.style.cursor = 'not-allowed';
                            circle.setAttribute('fill', this.enSesionEventosColor);
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.en_sesion_abonos) {
                            circle.setAttribute('ocupada', 'true');
                            circle.style.cursor = 'not-allowed';
                            circle.setAttribute('fill', this.enSesionAbonosColor);
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.venta) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.vendidaEventosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.comprada_abonos) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.vendidaAbonosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.bloqueada_abonos) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.bloqueadaAbonosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        }

                        if(plaza.info_ocupada && plaza.info_ocupada.numero_pedido){
                            circle.addEventListener('click', () => {
                                let url = `/admin/eventos/${this.$route.params.evento_id}/sesiones/${this.$route.params.sesion_id}/ventas?n_pedido=${plaza.info_ocupada.numero_pedido}`;
                                window.open(url, '_blank');
                            });
                        }

                        if (plaza.info_acceso?.accedido) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.validadaColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title);
                        }
                    }
                });

                this.svgRendered = tempDiv.firstElementChild;
            },
            drawPopover(circle, plaza, title = null, content = '') {
                if (plaza.precios.length === 0) {
                    content += `<div><strong>No disponible</strong></div>`;
                } else if ((plaza.disponible || plaza.libre) && plaza.precios.length > 0) {
                    content += `<div><strong>Disponible</strong></div>`;
                    content += `Desde: ${this.$n(this.getPrecioPlaza(plaza), "currency")}`;
                }

                if (plaza.ocupada) {
                    if (plaza.etiqueta_bloqueo) {
                        content += `<div><strong>` + plaza.etiqueta_bloqueo.name + `</strong></div>`;
                    }
                    if (plaza.ocupada.reserva_id) {
                        content += `<div><strong>Reservada</strong></div>`;
                    } else if (plaza.ocupada.bloqueada) {
                        content += `<div><strong>Plaza bloqueada</strong></div>`;
                    } else if (plaza.ocupada.bloqueada_abonos) {
                        content += `<div><strong>Plaza bloqueada en abonos</strong></div>`;
                    }
                    if (plaza.ocupada.venta) {
                        content += `<div><strong>Vendida</strong></div>`;
                        if (plaza.info_ocupada) {
                            if (plaza.info_ocupada.numero_pedido) {
                                content += '<div><strong>Nº del pedido: </strong>' + plaza.info_ocupada.numero_pedido + '</div>';
                            }
                            if (plaza.info_ocupada.nombre_venta && plaza.info_ocupada.apellidos_venta) {
                                content += `<div><strong>Nombre: </strong>${plaza.info_ocupada.nombre_venta + ' ' + plaza.info_ocupada.apellidos_venta}</div>`;
                            }
                            if (plaza.info_ocupada.numero_abonado && !plaza.ocupada.renovado) {
                                content += `<div><strong>Abonado no renovado</strong></div>`;
                            }
                        }
                    }
                    if (plaza.ocupada.comprada_abonos) {
                        content += `<div><strong>Vendida en abonos</strong></div>`;
                    }
                    if (plaza.ocupada.sesion) {
                        content += `<div><strong>En sesión</strong></div>`;
                    }
                    if (plaza.ocupada.en_sesion_abonos) {
                        content += `<div><strong>En sesión en abonos</strong></div>`;
                    }
                }

                if (plaza.info_acceso?.accedido) {
                    content += `<div><strong>Hora de acceso: </strong>` + plaza.info_acceso.hora_acceso + `</div>`;
                }

                if (this.load_panzoom) {
                    const popoverOptions = {
                        title: title,
                        content: content,
                        trigger: 'hover',
                        html: true
                    }
    
                    new Popover(circle, popoverOptions);                
                }
            },
            getButacaId(circle) {
                const id = circle.id;
                const idParts = id.split("-");

                return idParts[1];
            },
            getButacaName(plaza) {
                const nButaca = plaza.butaca;
                const nFila = plaza.fila;
                const sector = plaza.sector_name;
                const visibilidad_reducida = plaza.visibilidad_reducida;
                const porcentaje_visibilidad = plaza.porcentaje_visibilidad;
                let name = '';

                if (sector) {
                    name += `Sector: ${sector} - `;
                }

                if (!nButaca && !nFila) {
                    name += `Plaza: ${plaza.numero}`;
                } else {
                    name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                }

                if (visibilidad_reducida) {
                    name += '<span class="text-danger"> Visibilidad Reducida</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },
            checkDisponibilidad(plaza) {
                var disponible = plaza.libre || plaza.disponible;

                if (!disponible && plaza.ocupada) {
                    if (plaza.ocupada.bloqueada && (plaza.ocupada.reserva_id == null && !plaza.ocupada.venta && !plaza.ocupada.sesion && !plaza.ocupada.evento_venta && !plaza.ocupada.evento_sesion && !plaza.ocupada.renovado && !plaza.ocupada.evento_bloqueo)) {
                        disponible = true;
                    }
                }

                return disponible;
            }
        },
        components : { SvgPanZoom, LeafletComponent, LeyendaColorEventos },
    }
</script>